<template>
  <div :class="['info-box', colorClass]">
    <div class="info-box-content">
      <span class="info-box-icon">
        <i :class="iconClasses"></i>
      </span>
      <div class="info-box-items">
        <span class="info-box-text">{{text}}</span>
        <span class="info-box-number">{{number}}</span>
      </div>
    </div>
    <div class="info-box-graph">
      <v-sparkline
      :fill="fill"
      :gradient="selectedGradient"
      :line-width="width"
      :padding="padding"
      :smooth="radius || false"
      :value="value"
      auto-draw
    ></v-sparkline>
      <!-- <div class="progress">
        <div class="progress-bar" :style="{width: progress + '%'}"></div>
      </div> -->
      <span class="progress-description">{{description}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBox',
  props: {
    text: {
      type: String,
      required: true
    },
    number: {
      type: String,
      default: ''
    },
    progress: {
      type: Number,
      default: 0,
      validator(value) {
        return value >= 0 && value <= 100
      }
    },
    description: {
      type: String,
      default: ''
    },
    iconClasses: {
      type: Array,
      default: []
    },
    colorClass: {
      type: String,
      default: 'bg-default'
    },
    colorItem: {
      type: Number,
      default: 1
    },
    selectedGradient: {
      type: Array,
      default: ''
    }
  },
  data: () => ({
    fill: true,
    padding: 0,
    radius: 0,
    value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    width: 500
  })
}
</script>



// WEBPACK FOOTER //
// ProcessInfoBox.vue?c2cce982